import type { EventOccurrenceViewModel, FunctionViewModel } from '@trinnvis/dabih-api-client';
import type { OrganizationState } from '../../types';
import { LocalDate } from '../../../utilities/local-date';
import type { EventInstance } from './event-instance';
import { listNamesAsText } from '../employees/list-names-as-text';
import { eventDoneText } from './event-done-text';
import { sortBy } from 'lodash';
import type { ContactsAsUsers } from '../partners/contacts-as-users';
import type { SelectDropdownOption } from '../../../library/editors/elements/select-dropdown-option';
import { eventAssigneesText } from '../../eventAssigneesText';
import { t } from 'src/i18n';

export function taskEventInstancesFunction(
  events: EventOccurrenceViewModel[],
  organization: OrganizationState,
  employeesAndContactsOptions: SelectDropdownOption[],
  employeeNamesI: { uuid: string; status: string; name: string }[],
  contacts: ContactsAsUsers[],
  functions: FunctionViewModel[],
  organizationId: number,
  currentUserUuid: string,
  today: LocalDate,
  singleUserVersion: boolean,
  context: string,
): EventInstance[] {
  const result: EventInstance[] = [];
  events.forEach((event: EventOccurrenceViewModel): void => {
    if (event.date !== null && event.date !== undefined) {
      let functionName = '';
      let employeeNames = '';
      let myTask = true;
      if (!singleUserVersion) {
        const employeesList = event.employees ?? [];
        if (event.functionUuid) {
          functionName = organization.functionsById[event.functionUuid].name ?? '';
        }
        const employeeNamesList = listNamesAsText(employeeNamesI, employeesList);
        employeeNames = employeeNamesList.charAt(0).toUpperCase() + employeeNamesList.slice(1);
        myTask =
          employeesList.includes(currentUserUuid) ||
          (event.contacts && event.contacts.length > 0 && event.contacts.includes(currentUserUuid)) ||
          event.functionUuid !== '';
      }
      const locked = false;
      const accessible = true;
      const dayTask = event.time === undefined;
      let hour = event.time ?? '';
      if (hour !== '') {
        hour = t('events.timeAtPrefix') + hour.replace(':', '.');
      }
      const date = LocalDate.fromString(event.date).toStringForDisplayWithDayOfWeekAndYear();
      const dateAndTimeDisplay = date.charAt(0).toUpperCase() + date.slice(1) + hour;
      let sortTime = event.date ?? '';
      let doneText = '';
      if (event.doneDate) {
        sortTime = event.doneDate;
        doneText = t('content.donePrefix') + eventDoneText(event, employeesAndContactsOptions, singleUserVersion);
      }
      let overdue = false;
      if (
        event.persistent &&
        LocalDate.fromString(event.date).isBefore(today) &&
        !event.doneDate &&
        !event.doneByEmployeeUuid
      ) {
        overdue = true;
      }
      result.push({
        event,
        uuid: '', // TODO
        hasDraft: false, // TODO
        eventUuid: event.uuid,
        eventName: event.name !== undefined ? event.name : '',
        eventNotes: '', // TODO event.notes,
        href: '/account/' + organizationId + '/' + context + '/eventOccurrences/' + event.uuid,
        time: (event.date ?? '') + event.time,
        sortTime,
        dateAndTimeDisplay,
        dayTask,
        overdue,
        employees: event.employees,
        employeeNames,
        functionUuid: event.functionUuid,
        functionName,
        contacts: event.contacts,
        assignee: eventAssigneesText(event, functions, employeeNamesI, contacts),
        myTask,
        timeOfDayDisplay: dayTask ? '' : (event.time ?? ''), // TODO r.timeDisplay(),
        dateTimeForOrdering: (event.date ?? '') + event.time,
        doneDate: event.doneDate,
        doneByEmployeeUuid: event.doneByEmployeeUuid,
        doneByContactPersonUuid: event.doneByEmployeeUuid,
        doneText,
        locked,
        accessible,
      });
    }
  });
  return sortBy(result, [(item) => item.time]);
}
